import React, { useState, useRef, useEffect } from 'react';
import './TranslationForm.css';

function TranslationForm({ onTranslate, loading, error }) {
  const [text, setText] = useState('');
  const [sourceLang, setSourceLang] = useState('en');
  const [targetLang, setTargetLang] = useState('ja');
  const textInputRef = useRef(null);

  // loading が false に戻ったときにフォーカスを復帰
  useEffect(() => {
    if (!loading) {
      textInputRef.current?.focus();
    }
  }, [loading]);

  const handleSwapLanguages = () => {
    setSourceLang(targetLang);
    setTargetLang(sourceLang);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (text.trim()) {
      onTranslate(text, sourceLang, targetLang);
      setText('');
    }
  };

  const languages = {
    en: '英語',
    ja: '日本語',
    zh: '中国語',
    ko: '韓国語',
    fr: 'フランス語',
    es: 'スペイン語',
    de: 'ドイツ語',
  };

  return (
    <div className="translation-form">
      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit} className="form-input-container">
        <div className="language-selector-bottom">
          <select
            value={sourceLang}
            onChange={(e) => setSourceLang(e.target.value)}
            disabled={loading}
            className="lang-select"
            title="元の言語"
          >
            {Object.entries(languages).map(([code, name]) => (
              <option key={code} value={code}>
                {name}
              </option>
            ))}
          </select>

          <button
            type="button"
            className="swap-button-bottom"
            onClick={handleSwapLanguages}
            disabled={loading}
            title="言語を入れ替え"
          >
            ⇄
          </button>

          <select
            value={targetLang}
            onChange={(e) => setTargetLang(e.target.value)}
            disabled={loading}
            className="lang-select"
            title="翻訳先の言語"
          >
            {Object.entries(languages).map(([code, name]) => (
              <option key={code} value={code}>
                {name}
              </option>
            ))}
          </select>
        </div>

        <div className="input-group">
          <input
            ref={textInputRef}
            type="text"
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder="翻訳したいテキストを入力..."
            disabled={loading}
            className="text-input"
          />
          <button
            type="submit"
            className="submit-button"
            disabled={loading || !text.trim()}
            title="翻訳"
          >
            {loading ? '...' : '→'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default TranslationForm;
